const HelpPaper = ({ device, selectedDevice, open, setHelpOpen }) => {
	const handleClose = () => {
		setHelpOpen(false)
	};

	return <div
		hidden={device === selectedDevice ? !open : true}
		onClick={handleClose}
		onClose={handleClose}
		className={device}
	>
		<div onClick={handleClose}>
			<div className="block break-words w-full py-[25px]">
				<div className="text-[16px] md:text-[15px] whitespace-normal help-list-text">
					<div className="mb-4">Benvinguts als Minimots, els mots encreuats de VilaWeb. A continuació us donem algunes indicacions per a saber com s’hi juga:</div>
					<ul className="ml-4">
						<li>
							• Quan pitgeu sobre una casella, se selecciona i es torna de color carabassa.
							La resta de caselles que formen part de la paraula agafaran un color de fons semblant.
						</li>
						<li>
							• Quan seleccioneu una casella, es mostra la definició del mot que en aquell moment ocupen les caselles acolorides.
						</li>
						<li>
							• Si amb una casella seleccionada es mostren les caselles on hi ha un mot horitzontal, pitjant a sobre canviarà
							l’orientació i es mostraran les de la paraula vertical. I a la inversa, si veiem les caselles d’una paraula vertical
							i volem canviar d’orientació, tornem a pitjar la casella seleccionada per veure la paraula horitzontal.
						</li>
						<li>
							• Quan es mostren les caselles que formen un mot, podem escriure amb el teclat digital la paraula que creiem que
							hi ha d’anar. El mot es començarà a escriure a partir de la casella que tenim seleccionada.
						</li>
						<li>
							• A sobre dels minimots hi ha un cronòmetre amb el temps que hi hem dedicat. Es pot pitjar el botó de pausa
							per aturar el joc momentàniament.
						</li>
						<li>
							• El joc es va desant automàticament. Si ja teniu mots introduïts i sortiu del joc, no perdreu pas allò que heu fet:
							quan torneu, veureu les paraules que havíeu entrat. Això, és clar, si feu servir el mateix dispositiu on havíeu jugat la darrera vegada.
						</li>
						<li>
							• Podeu accedir a les opcions del joc pitjant la icona de roda dentada. Veureu les següents:
							<ul className="ml-4">
								<li>
									• <b>Minimots anteriors</b>: us porta a Minimots de dies previs.
								</li>
								<li>
									• <b>Comprovar</b>: comprova si els mots que hem introduït són correctes.
									Les lletres col·locades correctament es mostren de color verd; les incorrectes, de color vermell.
								</li>
								<li>
									• <b>Resoldre</b>: es resol el mot encreuat i es mostren totes les paraules correctes. El joc s’ha acabat.
								</li>
								<li>
									• <b>Reiniciar</b>: esborra tots els mots que hem introduït i deixa la graella buida.
									També posa a zero el temps del cronòmetre.
								</li>
							</ul>
						</li>
						<li>
							• Per posar-vos en contacte amb nosaltres, escriviu-nos a <a className="!underline !text-[#ff6600] !hover:text-[#ff6600] !visited:text-[purple]" href="mailto:suport@vilaweb.cat">suport@vilaweb.cat</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
}
export default HelpPaper